export default __webpack_public_path__ + "static/media/useDefaultLineItems.76b2c944.png";